var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProspectImagePlaceholder = function SvgProspectImagePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#F5F5F5",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9A9A9A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M44 52v-7.2c0-.747 0-1.12-.145-1.405a1.33 1.33 0 0 0-.583-.583c-.285-.145-.659-.145-1.405-.145h-3.734c-.746 0-1.12 0-1.405.145a1.34 1.34 0 0 0-.583.583C36 43.68 36 44.053 36 44.8V52m-8-18.667a4 4 0 1 0 8 0 4 4 0 1 0 8 0 4 4 0 1 0 8 0M32.267 52h15.466c1.494 0 2.24 0 2.811-.29.502-.256.91-.664 1.165-1.166.291-.57.291-1.317.291-2.81V32.266c0-1.494 0-2.24-.29-2.811a2.67 2.67 0 0 0-1.166-1.165c-.57-.29-1.317-.29-2.81-.29H32.266c-1.494 0-2.24 0-2.811.29-.502.256-.91.664-1.165 1.166-.291.57-.291 1.317-.291 2.81v15.467c0 1.494 0 2.24.29 2.811.256.502.664.91 1.166 1.165.57.291 1.317.291 2.81.291"
  })));
};
export default SvgProspectImagePlaceholder;